// extracted by mini-css-extract-plugin
module.exports = {"image":"UploadCoverPhotoModal_image__1gCBq","upload-image-container":"UploadCoverPhotoModal_upload-image-container__3eJc6"};